import { ACTION_TYPES } from '@components/table/action/constants.ts';
import { BORDER_COLORS as BC, SURFACE_COLORS as SC, TEXT_COLORS as TC } from '@constants/colors.ts';
import { BODY_XS_XS_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

import type { ActionType } from '../types.ts';

const getActionWrapperColors = (type: ActionType) => {
    switch (type) {
        case ACTION_TYPES.ResettedDefault:
        case ACTION_TYPES.Draft:
            return { border: BC.warning, background: SC.warning };
        case ACTION_TYPES.Published:
        case ACTION_TYPES.ReActivated:
            return { border: BC.success, background: SC.success };
        case ACTION_TYPES.Deleted:
            return { border: BC.error, background: SC.error };
        case ACTION_TYPES.Edited:
        case ACTION_TYPES.RePublished:
            return { border: BC.focus, background: SC.white };
        case ACTION_TYPES.Deactivated:
        case ACTION_TYPES.Activated:
        case ACTION_TYPES.Archive:
        case ACTION_TYPES.AutoDeactivated:
        default:
            return { border: BC.default, background: SC.white };
    }
};

export const TableActionWrapper = styled.div<{ type: ActionType }>`
    display: flex;
    padding: 4px 8px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 48px;
    width: fit-content;

    ${({ type }) => {
        const { border, background } = getActionWrapperColors(type);

        return `
            border: 1px solid ${border};
            background: ${background};
        `;
    }}
`;

const getActionTitleColor = (type: ActionType) => {
    switch (type) {
        case ACTION_TYPES.ResettedDefault:
        case ACTION_TYPES.Draft:
            return TC.warning;
        case ACTION_TYPES.Published:
        case ACTION_TYPES.ReActivated:
            return TC.success;
        case ACTION_TYPES.Deleted:
            return TC.error;
        case ACTION_TYPES.Edited:
        case ACTION_TYPES.RePublished:
            return TC.action;
        case ACTION_TYPES.Activated:
        case ACTION_TYPES.Deactivated:
        case ACTION_TYPES.AutoDeactivated:
        case ACTION_TYPES.Archive:
        default:
            return TC.body;
    }
};

export const Title = styled.div<{ type: ActionType }>`
    color: ${({ type }) => getActionTitleColor(type)};
    ${BODY_XS_XS_STYLES};
`;
